import { render } from "./VideoEditing.vue?vue&type=template&id=177c1b36&scoped=true"
import script from "./VideoEditing.vue?vue&type=script&lang=js"
export * from "./VideoEditing.vue?vue&type=script&lang=js"

import "./VideoEditing.vue?vue&type=style&index=0&id=177c1b36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177c1b36"]])

export default __exports__